export interface QuickBooksInternalFieldOptionConstructor {
  key: string // Procurify default field key, e.g. 'vendor_name'
}

export class QuickBooksInternalFieldOption {
  readonly key: string

  constructor(data: QuickBooksInternalFieldOptionConstructor) {
    this.key = data.key
  }
}
